<section>

  <div class="container-one">
    <div class=" curve top-left-curve"></div>

    <div class="content">
      <h3>Welcome!</h3>

      <p>Streamlining school management for a brighter future.</p>

      <img src="/auth/teacher-student.png" alt="teacher teaching student">
    </div>

    <div class=" curve bottom-right-curve"></div>
  </div>

  <div class="container-two">
    <img class="school-logo" src="/auth/graduate.svg" alt="">

    <h3>Add a School</h3>

    <form #schoolForm="ngForm" (ngSubmit)="createSchool(schoolForm)">

      <div>
        <label for="schoolName">School Name</label>
        <input required [(ngModel)]="schoolName" type="text" name="schoolName" id="schoolName" placeholder="eg. Great Minds Prep Sch.">
      </div>

      <div>
        <label for="location">Location</label>
        <input required [(ngModel)]="location" type="text" name="location" id="location" placeholder="eg. Legon, Accra.">
      </div>

      <div class="btn-container">
        <button [disabled]="schoolForm.invalid" type="submit" class="button">
          @if (isLoading()) {
            <app-loading-indicator></app-loading-indicator>
          } @else {
            Confirm
          }
        </button>
      </div>
    </form>

  </div>
</section>
